import React from 'react'
import { Container, Row } from 'reactstrap';

//Import Breadcrumb
import Breadcrumbs from "../../../../Components/Common/Breadcrumb";

// Components
import CardUser from './CardUser';
import Settings from './Settings';

const DashboardBlog: React.FC = () => {

  document.title = "Dashboard | BizServe";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboards" breadcrumbItem="Customer Dashboard" />

          <Row>
            <CardUser dataColors='["--bs-primary", "--bs-warning"]' />
            <Settings />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default DashboardBlog;
